<template>
  <div>
    <div class="info-box" ref="InfoContainer">
      <InfoIcon ref="InfoIcon" class="info-icon" />
      <h6 v-if="this.title">{{this.title}}</h6>
      <p v-if="this.text">{{this.text}}</p>

      <div v-for="(m, i) in this.multipleMessages" :key="i + getId()">
        <h6 v-if="m.title">{{m.title}}</h6>
        <p v-if="m.text">{{m.text}}</p>
        <div class="multiple-message-spacer" v-if="i < maxDividerLength" />
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from "../../utils/helpers/functions";
import InfoIcon from "../../0_atoms/icons/InfoIcon.vue";

export default {
  name: "InfoContainer",
  props: {
    text: String,
    title: String,
    multipleMessages: Array
  },
  components: {
    InfoIcon
  },

  methods: {
    getId() {
      return Helpers.uuidv4();
    }
  },
  computed: {
    maxDividerLength() {
      return this.multipleMessages.length - 1;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../utils/assets/stylesheets/variables.scss";
// deploy
.info-box {
  padding: 30px;
  background-color: $secondary-lighten-4;
  // border: 1px solid $secondary-lighten-3;
  border-radius: $border-radius;
  overflow: hidden;
  position: relative;

  h6 {
    color: $secondary;
    font-weight: 600;
    z-index: 1 !important;
    position: relative;
  }

  p {
    color: $secondary;
    z-index: 1 !important;
    position: relative;
  }
}

.info-icon {
  fill: #d4f2fa;
  top: -10px;
  position: absolute;
  z-index: 0;
  height: 110%;
}

.multiple-message-spacer {
  display: block;
  height: 20px;
}
</style>
